export default __webpack_public_path__ + "static/media/GLOBE_LOOP.24ce896f.gif";